<template>
  <!-- <div>
    <div class="mdss-yy no-select">
      <div class="layout">
        <div class="swiper-wrapper">
          <div class="swiper-slide" style="width: 25%;" v-for="(data, idx) in listData" v-bind:key="idx">
            <a href="javascript:;" @click="clickTab($event, idx, data)" :ref="idx === 0 ? 'firstItem': null">{{ data.boardtitle }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="layout">
      <div class="introduce-wrap">
        <h2 class="title">{{ tabNm }}</h2>
        <div class="img-txt-box">
          <div class="img-box">
            <img :src="findimage()" :alt="tabNm+'썸네일'" :title="tabNm+'썸네일'" @error="errorImageHandler">
          </div>
          <div class="txt-box" v-html="orgnlBoardDescription"></div>
          <div class="introduce-down-wrap">
            <button type="button" class="default btn" @click="openTabUrl(descriptionUrl)" :title="tabNm+' 바로가기'">{{ tabNm }} 바로가기</button>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="layout">
    <div class="stats-info-txt" style="margin-top: 50px;">
      <p class="bullet-p">
        '특수분류'는 특정 분야의 고유한 특성을 반영하기 위하여 표준분류 항목을 발췌 또는 재분류한 분류체계를 말하며, <br class="pc-br">
        문화체육관광 분야의 특수분류는 현재 콘텐츠산업 특수분류, 저작권산업 특수분류, 관광산업 특수분류, 스포츠산업 특수분류가 개발되어 활용되고 있습니다.
      </p>
      <p class="bullet-p">각 특수분류의 자세한 내용은 '국가데이터처 통계분류포털'에서 확인할 수 있습니다.</p>
      <div class="stats-poter"><a :href="statsLclsfUrl" class="stats-info-link" target="_blank">통계분류포털 바로가기</a></div>
    </div>
    <!--
    <div class="stats-category">
      <ul>
        <li>
          <a href="#n" @click.prevent="categoryClick(copyrightUrl)">‘저작권 산업’ 특수분류</a>
        </li>
        <li>
          <a href="#n" @click.prevent="categoryClick(contentUrl)">‘콘텐츠 산업’ 특수분류</a>
        </li>
        <li>
          <a href="#n" @click.prevent="categoryClick(travelUrl)">‘관광 산업’ 특수분류</a>
        </li>
        <li>
          <a href="#n" @click.prevent="categoryClick(sportsUrl)">‘스포츠 산업’ 특수분류</a>
        </li>
      </ul>
    </div>
    -->
    <!-- 아이프레임 영역 -->
    <!--
    <div class="frame-area" style="background: #ddd; height: 500px;">
      <iframe :src="framUrl" title="특수분류 미리보기" frameborder="0" style="width: 100%; height: 100%; vertical-align: middle;" ></iframe>
    </div>
    -->
    <!-- // 아이프레임 영역 -->

  </div>
</template>

<script>
import * as api from '@/api/Notice.js'
import * as file from '@/api/common/file.js'
import * as staticApi from '@/api/Statistics.js'

export default {
	name: 'SpclCtgry',
	data () {
		return {
			tabIndex: -1,
			tabNm: '',
      boardId: '',
      boardType: '000349',
      descriptionUrl: '',
      orgnlBoardDescription: '',
      listData: [],
      statsLclsfUrl: 'https://kssc.mods.go.kr:8443/ksscNew_web/index.jsp',                                   //통계분류포털
      framUrl: '',
      copyrightUrl: 'https://kssc.kostat.go.kr:8443/ksscNew_web/kssc/common/selectIntroduce.do?gubun=2&bbsId=copy_ug&categoryNameCode=034&categoryMenu=001', //‘저작권 산업’ 특수분류
      contentUrl: 'https://kssc.kostat.go.kr:8443/ksscNew_web/kssc/common/selectIntroduce.do?gubun=2&bbsId=contents_ug&categoryNameCode=006&categoryMenu=001',   //‘콘텐츠 산업’ 특수분류
      travelUrl: 'https://kssc.kostat.go.kr:8443/ksscNew_web/kssc/common/selectIntroduce.do?gubun=2&bbsId=tre_ug&categoryNameCode=008&categoryMenu=001',    //‘관광 산업’ 특수분류
      sportsUrl: 'https://kssc.kostat.go.kr:8443/ksscNew_web/kssc/common/selectIntroduce.do?gubun=2&bbsId=sport_ug&categoryNameCode=009&categoryMenu=001',    //‘스포츠 산업’ 특수분류

		}
	},

	created () {
		this.initBoard()
	},

  mounted() {
    this.framUrl = this.copyrightUrl;
  },

	methods: {
    initBoard () {
		  this.searchBoardTotalList()
		},

    // 게시판 전체 목록
		async searchBoardTotalList () {

			const paramData = {
				boardType: this.boardType
			}

			const boardData = await api.searchBoardList(paramData)
			this.listData = boardData.data

      this.$nextTick(() => {
        if (this.$refs.firstItem) {
          this.$refs.firstItem[0].click()
        }
      })
		},

    // 썸네일
		findimage () {
			try {
				let fileGb = ''
				let directoryPath = ''
        if (this.tabIndex != -1) {
          let data = this.listData[this.tabIndex]
          for (const fileData of data.attachFileList) {
            fileGb = fileData.fileGb.toLowerCase()
            if (fileGb === '02') {
              if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'stage') {
                if (process.env.VUE_APP_SUBJECT_SERVER.indexOf("localhost") == -1) {
                  directoryPath = fileData.orgnlDirectoryPath.replace("/web/mcstmng/source", "/mng");
                  directoryPath = process.env.VUE_APP_ADMIN_SERVER_UPLOAD + directoryPath;
                } else {
                  directoryPath = fileData.orgnlDirectoryPath;
                }
              } else {
                directoryPath = fileData.directoryPath;
                directoryPath = directoryPath.replace('http:', 'https:');
              }
              console.log(directoryPath);
              return directoryPath;
            }
          }
        }
      } catch (e) {
        return require('@/assets/img/default_thumbnail.png')
      }
      return require('@/assets/img/default_thumbnail.png')
		},

		// 에러 이미지
		errorImageHandler(event) {
        event.target.src = require('@/assets/img/default_thumbnail.png');
    },

		// 첨부파일 다운로드
		async fileDownload (fileMgmNo) {
			// 파일 다운로드 파라미터 설정
			const params = {
				type: 'BOARD',
				fileMgmNo: fileMgmNo
			}

			// 파일 다운로드 호출
			await file.download(params)

			// 파일 다운로드 로그
			const logParams = {
				downMenu: this.tabNm,
				downCntn: fileMgmNo
			}
			await staticApi.insertExcelDownLog(logParams)
		},

		async clickTab (event, tabIndex, data) {
			this.tabIndex = tabIndex
			this.tabNm = data.boardtitle
      this.boardId = data.boardId
      this.descriptionUrl = data.descriptionUrl
      this.orgnlBoardDescription = data.orgnlBoardDescription

			const tabMenu = document.getElementsByClassName('swiper-slide')
			Array.from(tabMenu).forEach(obj => obj.classList.remove('on'))

			event.target.parentElement.classList.add('on')
		},

    // open URL
		async openTabUrl (descriptionUrl) {
			window.open(descriptionUrl, "_blank");

			const paramData = {
				boardId: this.boardId,
				boardType: this.boardType
			}

			await api.updateBoardHits(paramData)
		},
    categoryClick(url){
      this.framUrl = url;
    }
	}
}
</script>

<style scoped>
.mdss-yy .swiper-wrapper {
  padding: 0;
}
@media only screen and (max-width: 768px) {
  .mdss-yy .swiper-wrapper .swiper-slide{
    width:50% !important;
  }
  .no-select .swiper-wrapper{
    padding: 0px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .mdss-yy{
    height:auto;
  }
}
</style>
